// Google Consent Mode v2. Por defecto todo denegado (RGPD); solo se concede al aceptar el banner.

export const CONSENT_STORAGE_KEY = 'ml_consent';

export type ConsentChoice = 'granted' | 'denied';

const CONSENT_TYPES = ['ad_storage', 'ad_user_data', 'ad_personalization', 'analytics_storage'] as const;

export function buildConsentState(choice: ConsentChoice): Record<(typeof CONSENT_TYPES)[number], ConsentChoice> {
  return Object.fromEntries(CONSENT_TYPES.map((type) => [type, choice])) as Record<(typeof CONSENT_TYPES)[number], ConsentChoice>;
}

/**
 * Inline script rendered before GTM: sets the default (denied) state and re-applies a stored
 * "granted" choice on every page load so tags fire with the right consent from the first hit.
 */
export const CONSENT_DEFAULT_SCRIPT = `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', ${JSON.stringify({ ...buildConsentState('denied'), wait_for_update: 500 })});
try {
  if (localStorage.getItem('${CONSENT_STORAGE_KEY}') === 'granted') {
    gtag('consent', 'update', ${JSON.stringify(buildConsentState('granted'))});
  }
} catch (e) {}
`;
